import { Dialog } from "primereact/dialog";
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import Langs from "../../app/lang/langs";
import { useDispatch, useSelector } from "react-redux";
import { getCompanies } from "../../components/collabs/collabsSlice";
import { InputField } from "../../components/inputs/InputField";
import { showErrorToast } from "../../app/utils/helpers";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import moment, { max } from "moment";
import { Tag } from "primereact/tag";
import { addEmploymentPromise, getEmploymentPromises } from "../../components/employmentPromises/employmentPromisesSlice";


export default function EmploymentPromisesAddModal(props) {

    const dispatch = useDispatch();
    const mounted = useRef(false)
    const [selectedItem, setSelectedItem] = useState({})
    const companies = useSelector((state) => state.collabs.companies)

    useEffect(() => {
        if (props.visible) {
            dispatch(getCompanies());
        }
    }, [props.visible])

    const isMobile = useSelector((state) => state.settings.isMobile)

    const statusOptions = [
        { label: 'OK', value: 'OK' },
        { label: 'KO', value: 'KO' },
    ];

    const progressionOptions = [
        { label: "Attente d'envoi", value: "Attente d'envoi" },
        { label: 'Envoyé', value: 'Envoyé' },
        { label: 'Reçu', value: 'Reçu' }
    ];
    const titleOptions = [
        { label: 'M.', value: 'M.' },
        { label: 'Mme', value: 'Mme' },
        { label: 'Indéfini', value: 'Indéfini' }
    ];

    const progressionBodyTemplate = (option) => {
        const status = option?.value;
        let severity;
        switch (status) {
            case "Attente d'envoi":
                severity = 'warning';
                break;
            case 'Envoyé':
                severity = 'info';
                break;
            case 'Reçu':
                severity = 'success';
                break;
            default:
                severity = null;
        }
        return <Tag value={status} severity={severity} />;
    };
    const statusBodyTemplate = (opt) => {
        const status = opt?.value;
        let severity;
        switch (status) {
            case "OK":
                severity = 'success';
                break;
            case 'KO':
                severity = 'danger';
                break;
            default:
                severity = null;
        }
        return <Tag value={status} severity={severity} />;
    }
    const visibleFields = [
        { key: "id_company", type: "dropdown", options: companies, optionLabel: "label", optionValue: "value" },
        { key: "title", type: "dropdown", options: titleOptions, optionLabel: "label", optionValue: "value" },
        { key: "name", type: "string", InputFieldLabel: "NAME" },
        { key: "family_name", type: "string", InputFieldLabel: "FAMILY_NAME" },
        { key: "email", type: "string" },
        { key: "progression", type: "dropdown", options: progressionOptions, optionLabel: "label", optionValue: "value", itemTemplate: progressionBodyTemplate, valueTemplate: progressionBodyTemplate },
        { key: "status", type: "dropdown", options: statusOptions, optionLabel: "label", optionValue: "value", itemTemplate: statusBodyTemplate, valueTemplate: statusBodyTemplate },
        { key: "start_date", type: "date", showButtonBar: true },
        { key: "sent_date", type: "date", showButtonBar: true },
        { key: "request_date", type: "date", InputFieldLabel: "REQUEST_DATE", showButtonBar: true },
    ];
    const handleSave = (ep) => {
        if (ep && ep.title && typeof ep.title === "string" && ep.title !== "") {
            let sd = ep.start_date ? moment(ep.start_date).format("YYYY-MM-DD") : null
            let rd = ep.request_date ? moment(ep.request_date).format("YYYY-MM-DD") : null
            let snd = ep.sent_date ? moment(ep.sent_date).format("YYYY-MM-DD") : null
            ep.start_date = sd
            ep.request_date = rd
            ep.sent_date = snd
            dispatch(addEmploymentPromise({ employment_promise: ep }))
                .then(((actionResponse) => {
                    if (addEmploymentPromise.fulfilled.match(actionResponse)) {
                        if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                            dispatch(getEmploymentPromises())
                            handleClose();
                        }
                    }
                }))
        } else {
            showErrorToast(`Veuillez remplir les champs obligatoires "titre", "nom", et "prenom" .`)
        }
    }
    const handleClose = () => {
        props.setVisible(false);
        setSelectedItem({})
    }
    const footer = () => {
        return <Row className="d-flex justify-content-center" >
            <Col lg={2} xs={2}>
                <DynamicButton
                    onClick={() => handleSave(selectedItem)}
                    className='me-auto'
                    title={<Langs str="ADD" />}
                    active={true}
                    color="green"
                />
            </Col>
        </Row>
    }
    return (
        <Dialog
            visible={props.visible}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            draggable={false}
            dismissableMask={true}
            style={{ width: '55rem', height: "70vh", maxHeight: "100%", marginRight: 0 }}
            footer={footer}
            header={<Langs str="ADD_EMPLOYMENT_PROMISE" />}
        >
            {visibleFields.map(field => selectedItem &&
                <InputField field={field}
                    onChange={(e) => setSelectedItem(prev => ({ ...prev, [field.key]: e }))}
                    value={selectedItem && selectedItem[field.key]} />
            )}
        </Dialog>
    )
}